<template>
  <div class="ai-visibility-detail-topbar">
    <div class="ai-visibility-detail-topbar__actions">
      <span class="ai-visibility-detail-topbar__refresh">
        Last refresh: <strong>{{ formatDateTime(tracker.lastRunAt) }}</strong><template v-if="!hideNextRefresh"> • Next refresh: <strong>{{ formatDateTime(tracker.nextRunAt) }}</strong></template> •
        <strong>{{ creditsPerPeriod }}</strong> POP credits<template v-if="!hideRefreshPeriod"> / {{ refreshPeriodLabel }}</template>
      </span>
      <info-icon :info="{tooltip: refreshTooltipText}"/>
      <button
        type="button"
        class="ai-visibility-detail-topbar__run"
        :disabled="effectiveRunning"
        @click="$emit('run-now')"
      >
        {{ effectiveRunning ? 'Running...' : runNowLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import InfoIcon from '../ui/display/InfoIcon.vue'

export default {
  name: 'DetailTopBar',
  components: {
    InfoIcon,
  },
  props: {
    tracker: {
      type: Object,
      required: true,
    },
    running: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hideRefreshPeriod() {
      return this.tracker.refreshFrequency === 'once';
    },
    hideNextRefresh() {
      return this.tracker.nextRunAt === null || this.tracker.refreshFrequency === 'once';
    },
    refreshCadence () {
      return this.tracker.refreshFrequency || 'weekly'
    },
    refreshPeriodLabel () {
      const cadenceLabels = {
        weekly: 'week',
        monthly: 'month',
      }
      return cadenceLabels[this.refreshCadence] || this.refreshCadence
    },
    creditsPerPeriod () {
      return this.tracker.requiredCredits || 0
    },
    refreshTooltipText () {
      return `This tracker refreshes once per ${this.refreshPeriodLabel}. POP credits are charged each time the tracker refreshes.`
    },
    runNowLabel () {
      return this.tracker.runNowLabel || `Run now for ${this.creditsPerPeriod} POP credits`
    },
    effectiveRunning () {
      return this.running || Boolean(this.tracker.isRunning)
    },
  },
  methods: {
    formatDateTime(item) {
      const dateObj = new Date(item)
      const formatter = new Intl.DateTimeFormat('en-GB', {
          month: 'numeric',
          day: 'numeric'
        })
      return formatter.format(dateObj).replace(/\//g, '.');
    }
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-detail-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.ai-visibility-detail-topbar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.ai-visibility-detail-topbar__refresh {
  color: var(--v-mainColor-base);
  font-size: 16px;
  line-height: 1.45;

  strong {
    font-weight: 700;
    color: var(--v-mainColor-base);
    font-size: 16px;
  }
}

.ai-visibility-detail-topbar__run {
  min-height: 38px;
  border: 1px solid var(--v-mainColor-base);
  border-radius: 999px;
  background: transparent;
  color: var(--v-mainColor-base);
  cursor: pointer;
  font-size: 16px;
  padding: 0 18px;
}

.ai-visibility-detail-topbar__run:disabled {
  cursor: default;
  opacity: 0.7;
}

@media (max-width: 720px) {
  .ai-visibility-detail-topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .ai-visibility-detail-topbar__selector {
    width: 100%;
  }

  .ai-visibility-detail-topbar__actions {
    justify-content: flex-start;
  }
}
</style>
